<template>
  <Label :bold="bold" :text="positionsText" />
</template>

<script>
import {mapGetters} from "vuex";
import Label from "@/components/atoms/Label";

export default {
  name: "PositionsLabel",
  components: {Label},
  props: {
    positions: {
      type: Array
    },
    bold: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters('system', ['consts']),
    positionsText() {
      return this.positions.map(position => this.jobName(position)).join('、')
    }
  },
  methods: {
    jobName(value) {
      if (this.consts.currentJob) {
        return this.consts.currentJob.find(job => job.value === value).label[0]
      }
      return null
    }
  }
}
</script>

<style scoped>

</style>